import React from 'react';
import { load } from 'core/utils/DynamicPreloading';

export const LazyWrappedCartConfig = React.lazy(load(() => import('core/context/WrappedCartConfig/WrappedCartConfig')));
export const LazyCartSummaryOverlay = React.lazy(load(() => import('component/common/CartSummaryOverlay/CartSummaryOverlay')));
export const LazyActivitiesHeader = React.lazy(load(() => import('component/common/Header/LazyActivitiesHeader')));
